import { NotifyHelper } from "../../../../helpers/toast";
import { eDgTuanKetQuaDefine } from "../../../action-types/danh-gia/tuan/IDgTuanKetQuaActionType";
import { generateActionForKey, generateActions } from "../../generateActions";

export const dgTuanKetQuaActions = {
    ...generateActions(eDgTuanKetQuaDefine, "DG_TUAN"),
    ...generateActionForKey(eDgTuanKetQuaDefine, "DG_TUAN", "SAVE_KETQUA_SUCCESS", () => NotifyHelper.Success("Saved!")),
    ...generateActionForKey(eDgTuanKetQuaDefine, "DG_TUAN", "SAVE_KETQUA_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eDgTuanKetQuaDefine, "DG_TUAN", "KET_QUA_LOAD_ERROR", (m) => NotifyHelper.Error(m))
}